module.exports = __webpack_public_path__ + "media/6.374ef3da.wav";